export default "__VITE_ASSET__BTLULOjP__"